module.exports = function (streamId, app, mod) {
  var externalClass = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  //
  // Do you want presentation videos to be mirrored (flipped) or not ???
  // The Css file flips local video so it is like looking in a mirror at yourself
  // Don't randomly apply in-line styling unless ABSOLUTELY necessary
  //

  var key = streamId;
  var videoAttribute = '';
  var volumeControl = true;
  if (streamId == 'local' || mod.publicKey === streamId) {
    key = mod.publicKey;
    videoAttribute = ' muted';
    volumeControl = false;
  }
  if (streamId == 'presentation' && (mod === null || mod === void 0 ? void 0 : mod.screen_share) === true) {
    videoAttribute = ' muted';
    volumeControl = false;
  }
  var name = app.keychain.returnIdentifierByPublicKey(key, true);
  var html = "<div id=\"stream_".concat(streamId, "\"  class=\"saito-videobox\">\n\t  <div class=\"default-video-mask hidden\"><i class=\"fa-solid fa-user-secret\"></i></div>\n      <video id=\"").concat(streamId, "\" ").concat(videoAttribute, " autoplay playsinline class=\"video-box ").concat(externalClass, "\"></video>\n      <div class=\"video-call-info\" data-id=\"").concat(key, "\">\n      \t<div class=\"call-icons\">\n\t\t\t\t\t<i id=\"audio-indicator\" class=\"fa fa-microphone\"></i>\n      \t</div>\n        <div class=\"video-call-identity\">\n          <div class=\"saito-address\" data-id=\"").concat(key, "\">").concat(name, "</div>\n          <span class=\"peer-transcription-status\" role=\"status\" hidden>Transcribing</span>\n        </div>\n      \t<div class=\"peer-call-list\"></div>");
  if (volumeControl) {
    html += '<div class="volume-control"> <i class="fa-solid fa-volume-high"></i> </div>';
  }
  html += "\n      </div>\n    </div>";
  return html;
};